import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Schedule from '@mui/icons-material/Schedule';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { useSessionTimeoutContext } from '../../contexts/SessionTimeoutContext';

export const SessionStatus: React.FC = () => {
  const { isExtended } = useSessionTimeoutContext();
  const [sessionTime, setSessionTime] = useState<string>('');

  useEffect(() => {
    const updateSessionTime = () => {
      const now = new Date();
      const timeString = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
      setSessionTime(timeString);
    };

    updateSessionTime();
    const interval = setInterval(updateSessionTime, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {isExtended && (
        <Tooltip title="Session extended successfully">
          <Chip
            icon={<CheckCircle />}
            label="Extended"
            color="success"
            size="small"
            variant="outlined"
          />
        </Tooltip>
      )}
      <Tooltip title="Session will timeout after 30 minutes of inactivity">
        <Box display="flex" alignItems="center" gap={0.5}>
          <Schedule fontSize="small" color="action" />
          <Typography variant="caption" color="text.secondary">
            {sessionTime}
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};
